import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { ImportMaps } from 'src/app/models/importmaps.model';

@Injectable({
  providedIn: 'root',
})
export class ImportmapsService {
  gnBaseURL: any;
  constructor(private http: HttpClient, private appURL: AppConfigService) {
    this.gnBaseURL = this.appURL.getServerUrl();
  }

  GetImportMapsByPlantId(id: string) {
    return this.http.get<ImportMaps[]>(
      this.gnBaseURL + 'ImportMaps/GetImportMapsByPlantId/' + id
    );
  }

  getImportMapById(id:string){
    return this.http.get<ImportMaps>(
      this.gnBaseURL + 'ImportMaps/GetImportMapById/' + id
    );
  }

  getImportmapByTrainId(plantid:string,trainid:string)
  {
    return this.http.get<ImportMaps[]>(
      this.gnBaseURL + 'ImportMaps/GetImportMapsByTrainId/' + plantid +'/' + trainid
    );
  }

  DeleteImportMaps(Id: string, model: number[]) {
    return this.http.post<number[]>(
      this.gnBaseURL + 'ImportMaps/'+ Id +'/action/deleteImportMaps',
      model
    );
  }
}
